<template>
  <div id="app">
    <el-container>
      <el-header>
        <nav-header />
      </el-header>
      
      <el-main>
        <router-view />
      </el-main>
      
      <el-footer style="height:100%">
        <app-footer />
      </el-footer>
      <!-- 在所有页面底部显示悬浮按钮 -->
      <floating-contact-buttons />
    </el-container>
  </div>
</template>

<script>
import NavHeader from '@/components/NavHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    NavHeader,
    AppFooter
  }
}
</script>

<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  line-height: 1.5;
  color: #333;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

@media screen and (max-width: 768px) {
  html, body {
    font-size: 14px;
  }
  
  .container {
    padding: 0 10px;
  }
}

// 移动端导航菜单样式
.mobile-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1000;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  
  &.active {
    transform: translateX(0);
  }
  
  .nav-header {
    padding: 15px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .close-btn {
      font-size: 24px;
      color: #666;
      background: none;
      border: none;
      padding: 5px;
    }
  }
  
  .nav-content {
    padding: 15px;
    
    .nav-item {
      padding: 12px 0;
      border-bottom: 1px solid #eee;
      
      a {
        color: #333;
        text-decoration: none;
        font-size: 16px;
      }
    }
  }
}

// 移动端菜单按钮
.menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  padding: 5px;
  
  @media screen and (max-width: 768px) {
    display: block;
  }
}

.el-header {
  padding: 0;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
}

.el-main {
  // padding-top: 80px;
  padding-top: 0px;
  padding: 0px;
  min-height: calc(100vh - 380px);
}

.el-footer {
  background: #2c3e50;
  color: #fff;
  // padding: 40px 0;
  margin-bottom: 10px;
}

@media screen and (max-width: 768px) {
  .el-main {
    padding: 60px 15px 20px;
  }
  
  .el-footer {
    padding: 20px 15px;
  }
}

/* 自定义滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Firefox 滚动条样式 */
* {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}
</style> 